export function capitaliseWord(string) {
  const lowercaseString = string.toLowerCase();
  return lowercaseString.charAt(0).toUpperCase() + lowercaseString.substr(1);
}